import pVendor from '@/constants/modules/p-vendor';
import pSKU from '@/constants/modules/p-sku';
import pPrice from '@/constants/modules/p-price';
import pTitle from '@/constants/modules/p-title';
import pDescription from '@/constants/modules/p-description';
import pFileUpload from '@/constants/modules/p-file-upload';

import dynamicButton from '@/constants/modules/dynamic-button';
import pCartButton from '@/constants/modules/p-cart-button';
import pViewMore from '@/constants/modules/p-view-more';
// import pSwatches from "@/constants/modules/p-swatches";
// import pVariants from "@/constants/modules/p-variants";
import pQuantity from '@/constants/modules/p-quantity';
import pImage from '@/constants/modules/p-image';

import aTitle from '@/constants/modules/article-title';
import aExcerpt from '@/constants/modules/article-excerpt';
import aDate from '@/constants/modules/article-date';
import aContent from '@/constants/modules/article-content';

import collectionTitle from '@/constants/modules/collection-title';
import collectionDesc from '@/constants/modules/collection-desc';
// import collectionToolbar from "@/constants/modules/collection-toolbar";
// import paginator from "@/constants/modules/paginator";

import countdown from '@/constants/modules/count-down';
import counter from '@/constants/modules/counter';
import breadcrumbs from '@/constants/modules/breadcrumbs';

type MODULE_INFO = {
  defaultClass: string;
  settingGroups: {
    [key: string]: {
      [key: string]: {
        selector: string;
        inherit?: string; // (subType|type).key
        cssAttr?: string;
        listUnit?: string;
      };
    };
  };
  designGroups?: {
    [key: string]: {
      [key: string]: {
        selector: string;
        inherit?: string; // (subType|type).key
        cssAttr?: string;
        listUnit?: string;
      };
    };
  };
};

export const MODULES_MAP: Record<any, MODULE_INFO> = {
  'a-title': aTitle,
  'a-excerpt': aExcerpt,
  'a-content': aContent,
  'a-date': aDate,
  'p-vendor': pVendor,
  'p-sku': pSKU,
  'p-price': pPrice,
  'p-title': pTitle,
  'p-description': pDescription,
  'p-file-upload': pFileUpload,
  'collection-title': collectionTitle,
  'collection-desc': collectionDesc,
  // "collection-toolbar": collectionToolbar,
  // "paginator": paginator,
  'dynamic-button': dynamicButton,
  'p-cart-button': pCartButton,
  'p-view-more': pViewMore,
  // "p-swatches": pSwatches,
  // "p-variants": pVariants,
  'p-quantity': pQuantity,
  'p-image': pImage,
  'count-down': countdown,
  counter: counter,
  breadcrumbs: breadcrumbs,
};
